import { render } from "./Reaction.vue?vue&type=template&id=2c0cce6e&scoped=true&ts=true"
import script from "./Reaction.vue?vue&type=script&lang=ts"
export * from "./Reaction.vue?vue&type=script&lang=ts"

import "./Reaction.vue?vue&type=style&index=0&id=2c0cce6e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0cce6e"]])

export default __exports__